<template>
	<a-modal class="contact-modal-wrapper" width="702px" :mask-closable="false" :visible="visible" title="查看用户信息"
		:footer="null" @cancel="$emit('onCancel')">
		<el-form ref="form" :model="dataInfo" label-width="80px">
			<el-form-item label="状态">
				<el-radio-group v-model="dataInfo.sex">
					<el-radio :label="1">正常</el-radio>
					<el-radio :label="2">冻结</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="学员姓名">
				<div>{{dataInfo.user_realname}}</div>
			</el-form-item>
			<el-form-item label="性别">
				<div>{{dataInfo.sex}}</div>
			</el-form-item>
			<el-form-item label="手机号">
				<div>{{dataInfo.mobile}}</div>
			</el-form-item>
			<el-form-item label="注册时间">
				<div>男</div>
			</el-form-item>
		</el-form>

		<slot />
	</a-modal>
</template>
<script>
	import {
		formData
	} from '../data/index';
	import ProvinceCity from './../components/ProvinceCity';
	export default {
		components: {
			ProvinceCity
		},
		props: ['title', 'visible', 'typeId','dataInfo'],
		data() {
			return {
				formData,
				typeData: [{
						id: 1,
						name: '药企'
					},
					{
						id: 2,
						name: '服务商'
					},
				],
				companyData: [],
			};
		},
		watch: {
			typeId(val) {
				this.onChangeType(val);
			},
		},
		mounted() {},
		methods: {
			// 获取企业
			async getCompanyData(url) {
				let result = await this.$http.post(url);
				if (result.data.status === 1) {
					let data = result.data.data.data_list.map((item) => {
						return {
							name: item.team_name ? item.team_name : item.companyInfo.qichacha_name,
							...item
						};
					});
					this.companyData = data;
				}
			},
			// 选择企业类型
			async onChangeType(value) {
				console.log('onChangeType -> value', value);
				if (value === 0) {
					this.companyData = [{
						id: 0,
						name: '所有公司'
					}];
				} else if (value === 1) {
					this.getCompanyData('/company/getCompanyList');
				} else {
					this.getCompanyData('/ServiceProvider/getCompanyList');
				}
			},
			// 自定义省市校验
			checkProvinceCity(rule, value, callback) {
				const error = [];
				if (!value || !value.province) {
					error.push('省份');
				}
				if (!value || !value.city) {
					error.push('城市');
				}
				if (error.length === 0) {
					callback();
				}
				callback(`请选择${error.join('和')}`);
			},
		},
	};
</script>